import Constants from '@/Constants';
import { EntityType } from '@/models/EntityTypes';
import Item from '@/models/Item';
import List from '@/models/List';
import { Program } from '@/models/Program';
import { ApplicationState } from '@/store';
import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import ContentRatingModal from '../ContentRatingModal';
import './style.scss';

interface Props {
    entityType: EntityType;
}

const MAX_STARS: number = 5;

const scrollRatingList: EntityType[] = [EntityType.COURSE, EntityType.PROGRAM];

const Rating: React.FC<Props> = ({ entityType }: Props) => {
    const { entity, strings } = useSelector((state: ApplicationState) => {
        let entity: List | Item | Program | undefined = undefined;

        switch (entityType) {
            case EntityType.COURSE:
                entity = state.lists.currentData.course;
                break;
            case EntityType.CONTENT:
                entity = state.itens.currentData.content;
                break;
            case EntityType.PROGRAM:
                entity = state.program.programData;
                break;
        }

        return {
            entity,
            strings: state.locale.data,
        };
    });

    const [showModal, setShowModal] = useState<boolean>(false);

    const scrollMarginTop: number = 40;

    const rating: number = entity?.rating || 0;

    const totalRating: number = entity?.totalRating || 0;

    const getStars = (): React.ReactNode => {
        const stars: JSX.Element[] = [];

        for (let i = 1; i <= MAX_STARS; i++) {
            stars.push(<i className={`material-icons${i > rating ? '' : ' selected'}`}>{Constants.icons.STAR}</i>);
        }

        return stars;
    };

    const rate = (event: React.MouseEvent<HTMLElement, MouseEvent>): void => {
        if (scrollRatingList.includes(entityType)) {
            scrollToRating(event);
        } else if (entityType === 'CONTENT') {
            setShowModal(true);
        }
    };

    const scrollToRating = (event: React.MouseEvent<HTMLElement, MouseEvent>) => {
        event.preventDefault();
        const element: HTMLElement = document.getElementById(Constants.RATING_SECTION_ID) as HTMLElement;
        const contentGoBackBar: HTMLElement = document.getElementById(Constants.CONTENT_GO_BACK_BAR_ID) as HTMLElement;
        const topImg: HTMLElement = document.getElementById(Constants.TOP_IMG_ID) as HTMLElement;

        if (element && contentGoBackBar && topImg) {
            window.scroll({
                behavior: 'smooth',
                left: 0,
                top: element.offsetTop + topImg.offsetHeight - scrollMarginTop,
            });
        }
    };

    return (
        <div className="rating-menu">
            <div className="rating-menu__totals">
                {rating > 0 && <span className="rating-menu__totals-average">{rating.toFixed(1)}</span>}
                {totalRating > 0 && (
                    <span className="rating-menu__totals-amount">{`${totalRating} ${(totalRating === 1
                        ? strings.EVALUATION
                        : strings.EVALUATIONS
                    ).toLocaleLowerCase()}`}</span>
                )}
            </div>

            <div className="rating-menu__star">{getStars()}</div>

            <button onClick={rate}>{strings.REVIEW}</button>

            {entityType === 'CONTENT' && entity && <ContentRatingModal onHide={() => setShowModal(false)} visible={showModal} />}
        </div>
    );
};

export default Rating;
